import { searchKeymap, openSearchPanel } from '@codemirror/search';
import { keymap } from '@codemirror/view';

/**
 * Розширення ПОШУКОВОЇ ПАНЕЛІ 
 * для CodeMiror 
 * @returns 
 */
export const searchExtension = () => {
    return keymap.of([
        ...searchKeymap,
        {
            key: "Mod-f", // Ctrl+F or Cmd+F
            run: (view) => {
            openSearchPanel(view);
            return true;
            },
        },
    ]);
}